
import Footer from '@/components/Shared/Footer/Footer'
import Navbar from '@/components/Shared/Navbar/Navbar'
import React from 'react'

const layout = ({ children }: { children: React.ReactNode }) => {
    return (
        <div>
            <Navbar />
            {children}
            <Footer />
        </div>
    )
}

export default layout
